<script lang="ts">
      let { class: className = '' } = $props()
</script>

<div class={className}>
      <svg class="w-full h-full" height="14" viewBox="0 -960 560 560" width="14" fill="#e8eaed" version="1.1" id="svg1">
            <defs id="defs1" />
            <path d="M 56,-400 0,-456 224,-680 0,-904 l 56,-56 224,224 224,-224 56,56 -224,224 224,224 -56,56 -224,-224 z" id="path1" style="fill:#000000;fill-opacity:1;stroke:none;stroke-opacity:1" />
      </svg>
</div>
